export default "__VITE_ASSET__DFuqMf2u__"